import React, {useContext, useEffect} from 'react'
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputText from "../components/Form/UiInputText";
import UiInputList from "../components/Form/UiInputList";
import UiInputTextarea from "../components/Form/UiInputTextarea";
import UiGridForm from "../components/Form/UiGridForm";
import AuthProvider from "../services/AuthProvider";
import { useNotification } from '../components/Core/NotificationProvider';

/**
 * O cliente é papel, e só isso: quem ele é (nome, apelido, documento, RG,
 * nascimento, gênero, estado civil, profissão, contato e endereço) mora no cadastro
 * de Pessoa, que este form referencia pelo suggest em vez de embutir. Pessoa que
 * ainda não existe se cadastra pela lupa do próprio suggest, que abre o grid de
 * Pessoa com o Adicionar.
 *
 * Ficam aqui o vendedor dono do cliente, o cliente PJ ao qual ele pertence e as
 * unidades consumidoras, que são do papel e não da pessoa.
 */
export default function ClienteForm(props: any){
    const { user } = useContext<any>(AuthProvider);
    const notification = useNotification();

    const methods = useForm({
        defaultValues: props.data
    });
    const { handleSubmit, reset } = methods;

    // Atualiza o form quando os dados chegam (para edição)
    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    const ligacaoList = [
        { id: 1, title: 'Monofasica' },
        { id: 2, title: 'Bifasica' },
        { id: 3, title: 'Trifasica' },
    ];

    const salvar = (dados: any) => {
        if (!dados.pessoa?.id) {
            notification.error('Cliente precisa da pessoa');
            return;
        }

        props.triggerSubmit(dados);
    };

    return (
        <>
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(salvar)} methods={methods}>
                    <WindowBody>
                        <div className="row">
                            <div className="col-lg-12">
                                <fieldset>
                                    <legend>Cliente</legend>
                                    <div className="row">
                                        <UiInputSuggest size={12} name="pessoa" router="unpessoa" idField="id" titleField="nome" label="Pessoa"/>
                                        { user.acesso == 1 &&
                                            <UiInputSuggest size={6} router="vendedor" idField="id" titleField="nome" name="vendedor" label="Vendedor"/>
                                        }
                                        <UiInputSuggest size={6} router="cliente" idField="id" titleField="nome" name="pj" label="Cliente PJ"/>
                                    </div>
                                </fieldset>
                            </div>

                            {/* Unidades consumidoras: são do cliente, não da pessoa. A data
                                fica em campo de texto para o valor gravado no JSON voltar
                                igual ao que o orçamento e a Celesc já leem. */}
                            <UiGridForm name="ucList" label="Unidades Consumidoras">
                                <UiInputText size={3} name="uc" label="UC"/>
                                <UiInputList size={3} name="ligacao" list={ligacaoList} idField="id" titleField="title" label="Ligação" />
                                <UiInputText size={2} name="dataInicial" label="Data Inicial"/>
                                <UiInputTextarea size={4} name="consumo" label="Consumo" onKeyPress={(e: any) => {
                                    if(e.key === 'Enter')
                                        e.preventDefault()
                                }}/>
                            </UiGridForm>
                        </div>
                    </WindowBody>

                    <WindowFooter>
                        <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                        <UiButton variant="primary" type="submit">Salvar</UiButton>
                    </WindowFooter>
                </Form>
            </FormProvider>
        </>
    )
}
